import React, { Fragment } from "react";

import { useIsAuthenticated } from "@azure/msal-react";
import { IonButton, IonLabel } from "@ionic/react";
import { useTranslation } from "react-i18next";

import { msalInstance } from "config/msalConfig";
import { useAppSelector } from "store";

interface IProps {
	navigate: (url: string) => void;
	onHide: () => void;
}
type PropsType = IProps;

const UserPopover: React.FC<PropsType> = (props) => {
	const { t, i18n } = useTranslation();
	const isOnline = useAppSelector((state) => state.connection.isOnline);
	const isAuthenticated = useIsAuthenticated();

	const LoggedInFragment = (
		<Fragment>
			<IonLabel>{i18n.format(t("logged_in"), "capitalize")}</IonLabel>
			<IonButton
				style={{ width: "100%" }}
				expand="full"
				data-testid="settingsButton"
				onClick={() => {
					props.navigate("/admin");
					props.onHide();
				}}
			>
				{i18n.format(t("settings"), "capitalizeEveryWord")}
			</IonButton>
			<IonButton
				style={{ width: "100%" }}
				expand="full"
				data-testid="signOutButton"
				onClick={() => {
					msalInstance.logoutRedirect();
					props.onHide();
				}}
			>
				{i18n.format(t("logout"), "capitalizeEveryWord")}
			</IonButton>
		</Fragment>
	);

	const ExpiredSessionfFragment = (
		<Fragment>
			<IonLabel>{i18n.format(t("session_expired"), "capitalize")}</IonLabel>
			<IonButton
				onClick={() => {
					window.location.reload();
				}}
			>
				{i18n.format(t("refresh_session"), "capitalize")}
			</IonButton>
		</Fragment>
	);
	const OfflineFragment = (
		<Fragment>
			<IonLabel>{i18n.format(t("network_unavailable"), "capitalize")}</IonLabel>
			<IonButton
				style={{ width: "100%" }}
				expand="full"
				onClick={() => {
					props.navigate("/admin");
					props.onHide();
				}}
			>
				{i18n.format(t("settings"), "capitalizeEveryWord")}
			</IonButton>
		</Fragment>
	);

	const renderContent = () => {
		if (!isOnline) {
			return OfflineFragment;
		}
		if (isAuthenticated) {
			return LoggedInFragment;
		}
		return ExpiredSessionfFragment;
	};
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				padding: "1rem",
			}}
		>
			{renderContent()}
		</div>
	);
};

export default UserPopover;
